import { CommonModule } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { AuthenticationStateModel } from '@app/store/auth/auth.state';
import { UserRole } from '@app/store/auth/userRole';
import { IncidentDetailsPageStore } from '../../incident-details-page.store';

@Component({
  standalone: true,
  selector: 'app-master-duplicate-references',
  imports: [CommonModule, MatIconModule],
  templateUrl: './master-duplicate-references.component.html',
  styleUrl: './master-duplicate-references.component.scss',
})
export class MasterDuplicateReferencesComponent {
  public readonly user = input<AuthenticationStateModel | null>(null);

  constructor(protected readonly store: IncidentDetailsPageStore) {}

  protected readonly duplicateIncidentIds = computed(() =>
    this.normalizeDuplicateIncidentIds(this.store.incident()?.incidentDuplicateIds),
  );

  protected readonly shouldShowMasterReference = computed(() => {
    return this.isAdminUser() && this.store.incident()?.masterIncidentId != null;
  });

  protected readonly shouldShowDuplicateReferences = computed(() => {
    return (
      this.isAdminUser() && this.store.incident()?.masterIncidentId == null && this.duplicateIncidentIds().length > 0
    );
  });

  private isAdminUser(): boolean {
    return !!this.user()?.roles?.includes(UserRole.Admin);
  }

  protected getIncidentUrl(incidentId: number): string {
    return `/incidents/${incidentId}`;
  }

  private normalizeDuplicateIncidentIds(incidentDuplicateIds: number[] | null | undefined): number[] {
    return (incidentDuplicateIds ?? []).filter((incidentId) => Number.isInteger(incidentId) && incidentId > 0);
  }
}
